import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardMedia,
  CardContent,
  Skeleton,
  Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';
import Tags from './Tags';

const LabTile = ({
  imageFileName = '',
  imageAlt = '',
  lab = '',
  description = '',
  status = '',
  labId = '',
  tags = [],
}) => {
  const [mediaLoading, setMediaLoading] = useState(true);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

  const getImageURL = () => {
    if (!imageFileName || imageFileName.length === 0) return undefined;

    if (imageFileName.startsWith('/')) {
      return imageFileName;
    }

    if (imageFileName.startsWith('images/')) {
      return `/${imageFileName}`;
    }

    return `/images/${imageFileName}`;
  };

  const imageURL = getImageURL();

  return (
    <Card sx={{ p: 2, maxWidth: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: 180,
        }}
      >
        {mediaLoading && !hasLoadedOnce && (
          <Skeleton variant='rectangular' width={300} height={200} />
        )}
        <CardMedia
          component='img'
          src={imageURL}
          alt={imageAlt}
          sx={{ height: '100%', maxWidth: '100%', objectFit: 'contain' }}
          onLoad={() => {
            setMediaLoading(false);
            setHasLoadedOnce(true);
          }}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'top',

        }}
      >
        <CardContent sx={{ px: 0, pb: 1 }}>
          <Typography variant='h3' component='h2' sx={{ mb: 1 }}>{lab}</Typography>
          <Typography>{description}</Typography>
        </CardContent>
      </Box>

      <CardActions sx={{ px: 0, mt: 'auto' }}>
        {status !== 'Active' ? (
          <Button disabled variant='text' component={Link} to={'/lab/' + labId}>
            Coming Soon
          </Button>
        ) : (
          <Button variant='outlined' component={Link} to={labId}>
            Open lab
          </Button>
        )}
      </CardActions>
      <Tags tags={tags} />
    </Card>
  );
};

export default LabTile;
